module.exports = __webpack_public_path__ + "static/img/ad-bar3.edd51b46.png";